import styled from 'styled-components';

export const Container = styled.div`
  > img {
    display: block;
    margin: 10px auto;
  }

  > button {
    font-family: 'Aller-Regular';
    font-size: 1.6rem;
    color: #939393;
    background-color: #fff;
  }

  @media (max-width: 1260px) {
    > button {
      margin: 40px auto;
    }
  }

  @media (max-width: 1024px) {
    margin-top: 40px;
  }

  @media (max-width: 560px) {
    width: 100%;
    > button {
      width: 100%;
    }
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
`;

export const AddButton = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 50px;
  height: 50px;
  border-radius: 50%;
  background-color: #19b441;
  text-align: center;

  > span {
    display: block;
    font-family: 'Aller-Light';
    font-size: 3rem;
    color: #fff;
  }
`;

export const AddCard = styled.span`
  font-family: 'Aller-Regular';
  font-size: 1.4rem;
  color: #165011;
  margin-left: 10px;
`;

export const CreditCardBanners = styled.img`
  margin-right: -210px;
  margin-top: 20px;

  @media (max-width: 1260px) {
    margin-right: 0px;
  }
`;

export const Tooltip = styled.div`
  font-family: 'Aller-Regular';
  font-size: 1.2rem;
  margin-top: 20px;
  color: #f00;
  text-align: center;
`;

export const TooltipPaymentOption = styled(Tooltip)`
  max-width: 400px;
  text-align: center;
  margin: 20px auto 0px auto;
`;
